import React from "react";
import { motion } from "framer-motion";
import {
  ShieldAlert,
  UserMinus,
  Handshake,
  Beer,
  ActivitySquare,
  MessageSquareText,
  FileText,
} from "lucide-react";

const policies = [
  {
    name: "Anti Sexual Harassment Policy",
    file: "Anti Sexual Harrasment Policy.pdf",
  },
  { name: "OHSEE Policy", file: "OHSEE Policy.pdf" },
  { name: "Social Media Policy", file: "Social Media Policy.pdf" },
  { name: "Drug and Alcohol Policy", file: "Drug and Alcohol Policy.pdf" },
  {
    name: "Company Business Ethics Policy",
    file: "Company Business Ethics Policy.pdf",
  },
  {
    name: "Bullying and Sexual Harassment Policy",
    file: "Bullying and sexual harassment policy.pdf",
  },
];

// Match icons to policy name
const getIconForPolicy = (name) => {
  const lower = name.toLowerCase();
  if (lower.includes("harassment")) return <ShieldAlert size={28} />;
  if (lower.includes("bullying")) return <UserMinus size={28} />;
  if (lower.includes("ethics")) return <Handshake size={28} />;
  if (lower.includes("drug") || lower.includes("alcohol"))
    return <Beer size={28} />;
  if (lower.includes("ohsee")) return <ActivitySquare size={28} />;
  if (lower.includes("social media")) return <MessageSquareText size={28} />;
  return <FileText size={28} />;
};

function Policies() {
  return (
    <section className="bg-gray-100 py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4 underline">Policies</h2>
          <p className="text-lg text-gray-600 mx-auto">
            Policies are the cornerstone of any well-run organization. They
            provide a structured framework of rules, guidelines, and
            expectations that govern the behaviour of employees and the
            operations of the business. Essentially, they translate a company's
            vision and values into day-to-day practices whether ashore or at
            sea.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6">
          {policies.map((policy, index) => (
            <a
              href={`pdfs/${policy.file}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-lg font-semibold text-gray-800 hover:text-blue-400 transition-colors"
            >
              <motion.div
                key={index}
                className="bg-white rounded-xl shadow border border-gray-100 p-5 flex items-center space-x-4 cursor-pointer"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{
                  scale: 1.03,
                  boxShadow: "0px 10px 30px rgba(0,0,0,0.1)",
                }}
              >
                <div className="text-blue-400">
                  {getIconForPolicy(policy.name)}
                </div>
                <div>
                  {policy.name}
                  {/* <p className="text-sm text-gray-500">{policy.file}</p> */}
                </div>
              </motion.div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Policies;
